import { render, staticRenderFns } from "./SourcesTable.vue?vue&type=template&id=fb45f7c8"
import script from "./SourcesTable.vue?vue&type=script&lang=js"
export * from "./SourcesTable.vue?vue&type=script&lang=js"
import style0 from "./SourcesTable.vue?vue&type=style&index=0&id=fb45f7c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports